import { Col, Row } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./UpcomingActDashboard.scss";
import { getUserIdFromToken, getEmailFromToken } from "../../shared/Common";
import EqButton from "../../custom/eqButton/EqButton";
import { ActivityTypeEnum } from "../../shared/enums";
import PrivateTrainingModal from "../../eqTrainer/PrivateTrainingModal/PrivateTrainingModal";
import SchoolPrivateTrainingModal from "../../eqSchool/SchoolPrivateTrainingModal/SchoolPrivateTrainingModal";
import { IUpcomingActivitiesResultDto } from "../../shared/interfaces/schoolTraining/school";

//interface UpcomingActList {
//    id: string;
//    title: string;
//    type: ActivityTypeEnum;
//    description: string;
//    startDate: number;
//    endDate: number;
//    createdById: string;
//    createdBy: string;
//    capacity: number;
//    orders: number;
//}

interface UpcomingActProps {
    TrainingHeading: string;
    Trainings: IUpcomingActivitiesResultDto[];
    onUpdate?: () => void;
    user: "student" | "trainer" | "school";
}

const UpcomingActDashboard: React.FC<UpcomingActProps> = (
    { Trainings, TrainingHeading, onUpdate, user,
        
     }) => {
    const [selectedTrainingId, setSelectedTrainingId] = useState<string | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isSchoolModalVisible, setIsSchoolModalVisible] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const displayedTraining = showAll ? Trainings : Trainings?.slice(0, 5);
    const currentUserId = getUserIdFromToken();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const ticksToMilliseconds = (ticks: number) => {
        const ticksSinceEpoch = ticks - 621355968000000000;
        return ticksSinceEpoch / 10000;
    };

    const disciplineTypeMap = {
        [ActivityTypeEnum.Training]: "Training",
        [ActivityTypeEnum.Event]: "Event",
        [ActivityTypeEnum.Product]: "Product",
        [ActivityTypeEnum.Course]: "Course",
        [ActivityTypeEnum.CourseLesson]: "CourseLesson",
    };

    const handleStudentActionClick = (item: IUpcomingActivitiesResultDto) => {
        switch (item.type) {
            case ActivityTypeEnum.Training:
                navigate(`/student/allTrainings?id=${item.id}`);
                break;
            case ActivityTypeEnum.Event:
                navigate(`/publicEventSingle?id=${item.id}`);
                break;
            case ActivityTypeEnum.Course:
                navigate(`/student/trainingCourse?id=${item.id}`);
                break;
            default:
                console.warn("Unknown activity type for student");
        }
    };

    const handleTrainerActionClick = (item: IUpcomingActivitiesResultDto) => {
        switch (item.type) {
            case ActivityTypeEnum.Training:
                setSelectedTrainingId(item.id);
                setIsModalVisible(true);
                break;
            case ActivityTypeEnum.Event:   
                navigate(`/trainer/activityBoard?tab=2&id=${item.id}`);
                break;
            default:
                console.warn("Unknown activity type for trainer");
        }
    };

    const handleSchoolActionClick = (item: IUpcomingActivitiesResultDto) => {
        switch (item.type) {
            case ActivityTypeEnum.Training:
                setSelectedTrainingId(item.id);
                setIsSchoolModalVisible(true);
                break;
            case ActivityTypeEnum.Event:
                navigate(`/school/activityBoard?tab=2&id=${item.id}`);
                break;
            case ActivityTypeEnum.Course:
                navigate(`/school/trainingCourse?id=${item.id}`);
                break;
            default:
                console.warn("Unknown activity type for school");
        }
    };

    const handleActionClick = (item: IUpcomingActivitiesResultDto) => {
        switch (user) {
            case "student":
                handleStudentActionClick(item);
                break;
            case "trainer":
                handleTrainerActionClick(item);
                break;
            case "school":
                handleSchoolActionClick(item);
                break;
            default:
                console.warn("Unknown user type");
        }
    };

    return (
        <div className="upcoming-act-dashboard">
            <div className="top-heading-div">
                <h3>{TrainingHeading}</h3>
            </div>
            {Trainings?.length > 0 ? (
                <>
                    <Row className="header-row" gutter={[16, 16]}>
                        <Col span={5} className="header-col">{t("startDate")}</Col>
                        <Col span={4} className="header-col">{t("type")}</Col>
                        <Col span={5} className="header-col">{t("title")}</Col>
                        <Col span={5} className="header-col">{t("availableSeats")}</Col>
                        <Col span={5} className="header-col">{t("actions")}</Col>
                    </Row>
                    <div className="table-style">
                        {displayedTraining?.map((item) => (
                            <Row key={item.id} className="table-row" gutter={[16, 16]}>
                                <Col span={5} className="table-col">
                                    {new Date(
                                        item.startDate > 9999999999999
                                            ? ticksToMilliseconds(item.startDate)
                                            : item.startDate
                                    ).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    })}
                                </Col>
                                <Col span={4} className="table-col">
                                    {disciplineTypeMap[item.type] || t("unknown")}
                                </Col>
                                <Col span={5} className="table-col truncate-text">{item.title}</Col>
                                <Col span={5} className="table-col">
                                    {item.type !== ActivityTypeEnum.Event ? (item.capacity ?? 0) - (item?.orders?? 0) : "-"}
                                </Col>
                                <Col span={5} className="table-col">
                                    <EqButton onClick={() => handleActionClick(item)} style={{ cursor: "pointer" }}>
                                        {t("view")}
                                    </EqButton>
                                </Col>
                            </Row>
                        ))}
                    </div>
                </>
            ) : (
                <p>{t("noDataAvailable")}</p>
            )}

            <PrivateTrainingModal
                trainingId={selectedTrainingId}
                visible={isModalVisible}
                onClose={() => setIsModalVisible(false)}

                
        //         areas={areas}
        // weekDays={weekDays}
        // population={population}
        // groupPopulation={groupPopulation}
        // trainerStudents={trainerStudents}
        // studentHorsesList={studentHorsesList}
            />
            <SchoolPrivateTrainingModal
                trainingId={selectedTrainingId}
                visible={isSchoolModalVisible}
                onClose={() => setIsSchoolModalVisible(false)}

                
        //         areas={areas}
        // weekDays={weekDays}
        // population={population}
        // groupPopulation={groupPopulation}
        // trainerStudents={trainerStudents}
        // studentHorsesList={studentHorsesList}
            />
        </div>
    );
};

export default UpcomingActDashboard;